import { message } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import apiCall from "../../../components/Api";
import StatusComponent from "../../../components/Common/StatusComponent";
import { ManufacturerBreadcrumbsList, navBarData } from "../Const";
import MasterListLayout from "../MasterListLayout";
import { usePaginatedList } from "../MedicineList/utils";

const ManufacturerList = () => {
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState({ id: "", status: false });
  const [loader, setLoader] = useState(true);

  const {
    records,
    count,
    pages,
    skip,
    limit,
    setLimit,
    handlePageChange,
    handleSortClick,
    debouncedSearch,
    list_api_call,
  } = usePaginatedList({ endpoint: "manufacturer/list" });

  const handleAdd = () => {
    navigate("/healthsy-services/order-medicines/masters/manufacturer-form");
  };

  const handleEdit = (id) => {
    navigate(
      `/healthsy-services/order-medicines/masters/manufacturer-form-edit/${id}`,
    );
  };

  const handleClose = () => {
    setDeleteModal({ id: "", status: false });
  };

  const handleDelete = async (id) => {
    try {
      await apiCall(`manufacturer/delete/${id}`, "DELETE", null, null);
      list_api_call();
      setDeleteModal({ id: "", status: false });
      message.success("Item deleted successfully");
      // handleDelete(id);
    } catch (error) {
      setDeleteModal({ id: "", status: false });
      message.error("Failed to delete item");
    }
  };

  const handleActive = async (id, status) => {
    try {
      await apiCall(
        `manufacturer/update/${id}`,
        "PATCH",
        { active: !status },
        null,
      );
      list_api_call();
      message.success("Status updated successfully");
    } catch (error) {
      message.error("Failed to update status");
    }
  };
  const columns = [
    {
      title: "S.No",
      render: (text, record, index) => Number(skip || 0) + (index + 1),
      key: "serial",
      fixed: "left",
      width: 80,
    },
    {
      title: "Status & Actions",
      render: (text, record) => (
        <StatusComponent
          text={text}
          record={record}
          // showPopup={showPopup}
          // setShowPopup={setShowPopup}
          handleEdit={handleEdit}
          setDeleteModal={setDeleteModal}
          handleActive={handleActive}
          title={"manufacturer_name"}
        />
      ),
      fixed: "left",
      key: "actions",
      width: 250,
    },
    {
      title: "Manufacturer Name",
      dataIndex: "manufacturer_name",
      key: "manufacturer_name",
      fixed: "left",
      width: 300,
      render: (text, record) => (
        <span className="">{record.manufacturer_name}</span>
      ),
    },
    {
      title: "Address of the Manufacturer",
      dataIndex: "address_of_manufacturer",
      key: "address_of_manufacturer",
      width: 350,
      render: (text, record) => (
        <span className="">{record.manufacturer_address}</span>
      ),
    },
    {
      title: "Customer Email",
      dataIndex: "customer_email",
      key: "customer_email",
      width: 350,
      render: (text, record) => (
        <span className="">{record.customer_email}</span>
      ),
    },
    {
      title: "Country Of Origin",
      dataIndex: "country_of_origin",
      key: "country_of_origin",
      width: 200,
      render: (text, record) => (
        <span className="">{record.country_of_origin}</span>
      ),
    },
  ];

  useEffect(() => {
    records.length > 0 && setTimeout(() => setLoader(false));
  }, [records]);
  return (
    <MasterListLayout
      title="manufacturer"
      breadcrumbsList={ManufacturerBreadcrumbsList("list")}
      onAdd={handleAdd}
      uploadApi="manufacturer/create-bulk"
      columns={columns}
      records={records}
      count={count}
      pages={pages}
      skip={skip}
      limit={limit}
      handlePageChange={handlePageChange}
      handleDelete={handleDelete}
      deleteModal={deleteModal}
      setDeleteModal={setDeleteModal}
      handleClose={handleClose}
      setLimit={setLimit}
      handleSortClick={handleSortClick}
      onChangeSearch={debouncedSearch}
      navBarData={navBarData}
      loader={loader}
    />
  );
};

export default ManufacturerList;
